"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedArticleItem = void 0;
var React = require("react");
var styles_1 = require("./styles");
var Dotdotdot = require("react-dotdotdot-r1");
exports.RelatedArticleItem = function (_a) {
    var articleItem = _a.articleItem, translate = _a.translate;
    var authors = articleItem.authors;
    var renderAuthors = function () {
        if (authors) {
            return (React.createElement(styles_1.Authors, null,
                translate.by,
                ": ",
                renderAuthorItems()));
        }
        return null;
    };
    var renderAuthorItems = function () { return (authors.map(function (author, i) { return (React.createElement(styles_1.Author, { key: i, href: author.url }, author.name)); })); };
    return (React.createElement(styles_1.Container, null,
        React.createElement(styles_1.Link, { href: articleItem.url },
            React.createElement(styles_1.Image, { src: articleItem.imageUrl })),
        React.createElement(styles_1.Details, null,
            React.createElement(styles_1.Link, { href: articleItem.url },
                React.createElement(Dotdotdot, { clamp: 2 },
                    React.createElement(styles_1.Title, null, articleItem.title))),
            React.createElement(Dotdotdot, { clamp: 2 },
                React.createElement(styles_1.Content, null, articleItem.content)),
            renderAuthors())));
};
